import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { LoadingPage } from './pages/LoadingPage';
import { DashboardPage } from './pages/DashboardPage';
import { CoursesPage } from './pages/CoursesPage';
import { CommunityPage } from './pages/CommunityPage';
import { ChatPage } from './pages/ChatPage';
import { AdvisoryPage } from './pages/AdvisoryPage';
import { AssessmentPage } from './pages/AssessmentPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { FAQPage } from './pages/FAQPage';
import { CalendarPage } from './pages/CalendarPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Home Page — Entry Point */}
        <Route path="/" element={<LoginPage data-id="element-3" />} data-id="element-2" />
        <Route path="/loading" element={<LoadingPage data-id="element-5" />} data-id="element-4" />

        {/* Authenticated Routes wrapped in Layout */}
        <Route path="/dashboard" element={<Layout data-id="element-7">
              <DashboardPage data-id="element-8" />
            </Layout>} data-id="element-6" />
        <Route path="/onboarding" element={<Layout data-id="element-10">
              <OnboardingPage data-id="element-11" />
            </Layout>} data-id="element-9" />
        <Route path="/courses" element={<Layout data-id="element-13">
              <CoursesPage data-id="element-14" />
            </Layout>} data-id="element-12" />
        <Route path="/community" element={<Layout data-id="element-16">
              <CommunityPage data-id="element-17" />
            </Layout>} data-id="element-15" />
        <Route path="/chat" element={<Layout data-id="element-19">
              <ChatPage data-id="element-20" />
            </Layout>} data-id="element-18" />
        <Route path="/advisory" element={<Layout data-id="element-22">
              <AdvisoryPage data-id="element-23" />
            </Layout>} data-id="element-21" />
        <Route path="/assessment" element={<Layout data-id="element-25">
              <AssessmentPage data-id="element-26" />
            </Layout>} data-id="element-24" />
        <Route path="/faq" element={<Layout data-id="element-28">
              <FAQPage data-id="element-29" />
            </Layout>} data-id="element-27" />
        <Route path="/calendar" element={<Layout data-id="element-31">
              <CalendarPage data-id="element-32" />
            </Layout>} data-id="element-30" />
        <Route path="/about" element={<Layout data-id="element-34">
              <AboutPage data-id="element-35" />
            </Layout>} data-id="element-33" />

        {/* Fallback route — sends to home page */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-37" />} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}